import { InfoArrowText } from './InfoArrowText';

export type { TypeInfoArrowTextProps } from './types';
export default InfoArrowText;
